import { JobStatus, Report } from '@/api/generatedApi';
import { useGetReport } from '@/hooks/api/reports/useGetReport';
import { useEffect, useState } from 'react';
import { RefetchManager } from './refetchManager';

export const useReportPolling = (parameters: { row: Report }) => {
  const [report, setReport] = useState<Report>(parameters.row);
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const refetchManager = RefetchManager.getInstance();

  const { report: fetchedReport, refetch } = useGetReport({
    id: shouldRefetch ? parameters.row.id : undefined,
  });

  useEffect(() => {
    const isInProgress = parameters.row.status === JobStatus.PENDING || parameters.row.status === JobStatus.RUNNING;
    if (isInProgress) {
      refetchManager.requestRefetch(parameters.row.id, () => {
        setShouldRefetch(true);
        refetch();
      });
    }
  }, [parameters.row.id, parameters.row.status, refetch, refetchManager]);

  useEffect(() => {
    if (fetchedReport) {
      setReport(fetchedReport);
      const isStillInProgress =
        fetchedReport.status === JobStatus.PENDING || fetchedReport.status === JobStatus.RUNNING;
      if (!isStillInProgress) {
        setShouldRefetch(false);
        refetchManager.completeRefetch(parameters.row.id);
      }
    }
  }, [fetchedReport, parameters.row.id, refetchManager]);

  useEffect(() => {
    return () => {
      refetchManager.completeRefetch(parameters.row.id);
    };
  }, [parameters.row.id, refetchManager]);

  return { data: report, fetchedData: fetchedReport };
};
